<template>
    <div
        class="mergeFieldsMobile__item"
        :class="{
            [`dropdown-item-field-${index}`]: true,
            disabledState: hasNotIntegration(item),
            'no-click': template,
        }"
        @click="applyMergeField(item)"
    >
        <span class="mergeFieldsMobile__item__info">
            <div class="mergeFieldsMobile__item__avatar">
                <figure v-if="item.photo_url" class="image is-16x16 is-avatar">
                    <img :src="item.photo_url" alt="" />
                </figure>
            </div>
            <div class="mergeFieldsMobile__item__label">
                {{ $filters.limit(item.label, 22) }}
            </div>
        </span>
        <span
            v-if="hasNotIntegration(item)"
            class="mergeFieldsMobile__item mergeFieldsMobile__item--unlink"
        >
            <fa-icon :icon="['fas', 'unlink']" />
        </span>
    </div>
</template>

<script>
import filters from '../../vue/filters';

export default {
    props: {
        template: { type: Boolean, default: false },
        item: { type: Object, default: {} },
        index: { type: Number },
        hasNotIntegration: { type: Function },
        checkDate: { type: Function },
    },

    data: () => ({
        hoverIcon: false,
    }),

    methods: {
        itemTooltip(item) {
            if (this.hasNotIntegration(item)) {
                return 'Integration disconnected. <a class="integrationReconnect" href="#">Reconnect.</a>';
            }

            const string = this.checkDate(item.value).join(' ');

            if (!string) {
                return '';
            }

            return filters.limit(string, 100);
        },

        mouseoverIcon(e) {
            const target = e.target;
            const tooltip = document.querySelector(`.tooltipIntegration--${this.index}`);
            const tooltipWrap = this.$refs.tooltip;

            if (
                (tooltipWrap && tooltipWrap.contains(target)) ||
                (tooltip && tooltip.contains(target))
            ) {
                const link = document.querySelectorAll('.integrationReconnect');

                if (link.length) {
                    link.forEach((el) => {
                        el.removeEventListener('click', this.redirectToIntegrations);
                        el.addEventListener('click', this.redirectToIntegrations);
                    });
                }

                this.hoverIcon = true;
            } else {
                this.hoverIcon = false;
            }
        },

        redirectToIntegrations(e) {
            e.preventDefault();

            this.$router.push('/settings/integrations');
        },

        applyMergeField(item) {
            this.$emit('applyMergeField', item);
        },
    },

    mounted() {
        document.addEventListener('mouseover', this.mouseoverIcon);
    },

    beforeUnmount() {
        document.removeEventListener('mouseover', this.mouseoverIcon);
    },
};
</script>
